import {
  INVENTORY_CREATE,
  BINLOCATION_ADD,
  WAREHOUSE_LIST,
  STOCK_TRANSFER_TABLE,
  STOCK_TRANSFER_CREATE,
  STOCK_TRANSFER_VIEW,
  STOCK_TRANSFER_BATCH,
  VOID_STOCK_TRANSFER_BATCH,
  VOID_STOCK_TRANSFER,
  VOID_STOCK_TRANSFER_ITEM,
  STOCK_TRANSFER_EDIT,
  WAREHOUSE_GET_ID,
  WAREHOUSE_LIST_WITH_CAPACITY,
  WAREHOUSE_BIN_LIST,
  WAREHOUSE_BIN_GENERATE,
  WAREHOUSE_BIN_ADD,
  WAREHOUSE_BIN_UPDATE,
  WAREHOUSE_BIN_DELETE,
  WAREHOUSE_BIN_DEFAULT_ITEMS_ADD,
  WAREHOUSE_BIN_DEFAULT_ITEMS_LIST,
  WAREHOUSE_BIN_SET_DEFAULT,
  WAREHOUSE_BIN_ITEMS_LIST,
  WAREHOUSE_EXPIRED_ITEMS_LIST,
} from "../types";

export const inventoryCreateAction = (data, onSuccess, onError) => {
  return {
    type: INVENTORY_CREATE,
    data,
    onSuccess,
    onError,
  };
};
export const binlocationAddAction = (data, onSuccess, onError) => {
  return {
    type: BINLOCATION_ADD,
    data,
    onSuccess,
    onError,
  };
};

export const warehouseListAction = (data, onSuccess, onError) => {
  return {
    type: WAREHOUSE_LIST,
    data,
    onSuccess,
    onError,
  };
};

export const warehouseGetIdAction = (data, onSuccess, onError) => {
  return {
    type: WAREHOUSE_GET_ID,
    data,
    onSuccess,
    onError,
  };
};

export const warehouseListWithCapacityAction = (data, onSuccess, onError) => {
  return {
    type: WAREHOUSE_LIST_WITH_CAPACITY,
    data,
    onSuccess,
    onError,
  };
};

export const warehouseBinListAction = (data, onSuccess, onError) => {
  return {
    type: WAREHOUSE_BIN_LIST,
    data,
    onSuccess,
    onError,
  };
};

export const warehouseBinGenerateAction = (data, onSuccess, onError) => {
  return {
    type: WAREHOUSE_BIN_GENERATE,
    data,
    onSuccess,
    onError,
  };
};

export const warehouseBinAddAction = (data, onSuccess, onError) => {
  return {
    type: WAREHOUSE_BIN_ADD,
    data,
    onSuccess,
    onError,
  };
};

export const warehouseBinUpdateAction = (data, onSuccess, onError) => {
  return {
    type: WAREHOUSE_BIN_UPDATE,
    data,
    onSuccess,
    onError,
  };
};

export const warehouseBinDeleteAction = (data, onSuccess, onError) => {
  return {
    type: WAREHOUSE_BIN_DELETE,
    data,
    onSuccess,
    onError,
  };
};

export const warehouseBinDefaultItemsAddAction = (data, onSuccess, onError) => {
  return {
    type: WAREHOUSE_BIN_DEFAULT_ITEMS_ADD,
    data,
    onSuccess,
    onError,
  };
};

export const warehouseBinDefaultItemsListAction = (data, onSuccess, onError) => {
  return {
    type: WAREHOUSE_BIN_DEFAULT_ITEMS_LIST,
    data,
    onSuccess,
    onError,
  };
};

export const warehouseBinSetDefaultAction = (data, onSuccess, onError) => {
  return {
    type: WAREHOUSE_BIN_SET_DEFAULT,
    data,
    onSuccess,
    onError,
  };
};

export const warehouseBinItemsListAction = (data, onSuccess, onError) => {
  return {
    type: WAREHOUSE_BIN_ITEMS_LIST,
    data,
    onSuccess,
    onError,
  };
};

export const stockTransferTableAction = (data, onSuccess, onError) => {
  return {
    type: STOCK_TRANSFER_TABLE,
    data,
    onSuccess,
    onError,
  };
};
export const stockTransferCreateAction = (data, onSuccess, onError) => {
  return {
    type: STOCK_TRANSFER_CREATE,
    data,
    onSuccess,
    onError,
  };
};
export const stockTransferEditAction = (data, onSuccess, onError) => {
  return {
    type: STOCK_TRANSFER_EDIT,
    data,
    onSuccess,
    onError,
  };
};
export const stockTransferViewAction = (data, onSuccess, onError) => {
  return {
    type: STOCK_TRANSFER_VIEW,
    data,
    onSuccess,
    onError,
  };
};
export const stockTransferBatchAction = (data, onSuccess, onError) => {
  return {
    type: STOCK_TRANSFER_BATCH,
    data,
    onSuccess,
    onError,
  };
};
export const voidStockTransferAction = (data, onSuccess, onError) => {
  return {
    type: VOID_STOCK_TRANSFER,
    data,
    onSuccess,
    onError,
  };
};
export const voidStockTransferItemAction = (data, onSuccess, onError) => {
  return {
    type: VOID_STOCK_TRANSFER_ITEM,
    data,
    onSuccess,
    onError,
  };
};
export const warehouseExpiredItemsListAction = (data, onSuccess, onError) => {
  return {
    type: WAREHOUSE_EXPIRED_ITEMS_LIST,
    data,
    onSuccess,
    onError,
  };
};
